import { render } from "./HotspotInfo.vue?vue&type=template&id=a49e99ac"
import script from "./HotspotInfo.vue?vue&type=script&lang=js"
export * from "./HotspotInfo.vue?vue&type=script&lang=js"

import "./HotspotInfo.vue?vue&type=style&index=0&id=a49e99ac&lang=css"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__